const c = (n) => {
  if (n) {
    const { url: t, name: e } = n;
    if (!t)
      return;
    const o = document.createElement("a");
    return o.href = t, o.target = "_blank", e !== void 0 && (o.download = e), document.body.appendChild(o), o.click(), document.body.removeChild(o), !0;
  }
  return null;
}, l = (n) => {
  if (n) {
    const { url: t } = n, e = new XMLHttpRequest();
    return e.open("GET", t, !0), e.responseType = "blob", e.onload = function() {
      const d = (window.URL || window.webkitURL).createObjectURL(this == null ? void 0 : this.response), r = document.createElement("a");
      r.href = d, r.download = t, document.body.appendChild(r), r.click(), document.body.removeChild(r);
    }, e.send(), !0;
  }
  return !1;
};
export {
  c as downloadFromDOM,
  l as downloadFromXHR
};
